// eslint-disable-next-line import/no-unresolved, import/extensions
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Collapsible from '../../components/Collapsible';
import Link from '../../components/Link';
import s from './Archives.css';

class Archives extends React.Component {
  static propTypes = {
    publication: PropTypes.string.isRequired,
  };

  state = {
    activeMap: {},
  };

  isCurrentYear(year) {
    return year === moment().format('YYYY');
  }

  isCaretUpOrDown(key) {
    return this.state.activeMap[key] ? 'fa-caret-down' : 'fa-caret-right';
  }

  makeInactive(key) {
    if (!this.state.activeMap[key]) {
      return;
    }
    const newMap = Object.assign({}, this.state.activeMap);
    newMap[key] = false;
    this.setState({ activeMap: newMap });
  }

  makeActive(key) {
    if (this.state.activeMap[key]) {
      return;
    }
    const newMap = Object.assign({}, this.state.activeMap);
    newMap[key] = true;
    this.setState({ activeMap: newMap });
  }

  renderYearArchive(monthsByYear) {
    return Object.keys(monthsByYear)
      .reverse()
      .map(key => {
        const yearMonths = monthsByYear[key];
        return (
          <div key={`archive-${key}`}>
            <Collapsible
              trigger={
                <span className={s.archiveYearHeader}>
                  <i
                    className={`font-15 fa color-magenta-light ${this.isCaretUpOrDown(
                      key,
                    )}`}
                  />
                  {` ${key}`}
                </span>
              }
              open={false}
              onClosing={() => this.makeInactive(key)}
              onOpening={() => this.makeActive(key)}
            >
              {yearMonths.map(item => this.renderArchiveLink(item))}
            </Collapsible>
          </div>
        );
      });
  }

  renderArchiveLink(month) {
    return (
      <li className={s.archiveLink} key={`archive-month-${month}`}>
        <Link
          to={`/publications/${this.props.publication}/archives/${moment(
            month,
            'MMMM YYYY',
          ).format('YYYY-MM')}`}
        >
          {month}
        </Link>
      </li>
    );
  }

  renderArchiveSection() {
    const startDate = moment('2013-11');
    const nowNormalized = moment().endOf(
      'month',
    ); /* the first of current month */
    const startDateNormalized = startDate
      .clone()
      .startOf(
        'month',
      ); /* the first of startDate + 1 Month - as it was asked for the months in between startDate and now */
    const months = [];
    const monthsShort = [];

    /* .isBefore() as it was asked for the months in between startDate and now */
    while (startDateNormalized.isBefore(nowNormalized)) {
      months.push(startDateNormalized.format('MMMM YYYY'));
      monthsShort.push(startDateNormalized.format('YYYY-MM'));
      startDateNormalized.add(1, 'months');
    }

    // reverse month and monthShort to sort
    months.reverse();
    monthsShort.reverse();

    const byYear = groupBy(months, month => moment(month, 'MMMM YYYY').year());

    return (
      <div>
        <div className={s.archiveNewsSection}>
          <ul>{this.renderYearArchive(byYear)}</ul>
        </div>
      </div>
    );
  }

  render() {
    return <div className={s.container}>{this.renderArchiveSection()}</div>;
  }
}

export default withStyles(s)(Archives);
